<template>
    <div class="works">
        <div class="work">
            <Audios :audios="audios"/>
        </div>
        <div class="bg-white w-100">
          <div class="d-flex w-100 justify-content-center">Excerpts used for demonstration purposes only.</div>
          <div class="d-flex w-100 justify-content-center">© All rights belong to the respective artists and rights holders.</div>
          <div class="d-flex w-100 justify-content-center">Produced, recorded, edited, and/or mixed by Kseniya Kawko</div>
        </div>
    </div>
</template>

<script>
    import Audios from '@/components/Audios'

    export default {
        components: {
            Audios,
        },
        data() {
          return {
            audios: [
              {
                title: ['Alicia Choi', 'G. Enescu “Impressions d\'enfance”'],
                image: 'img/01.jpg',
                description: 'Amaizing description',
                audio: 'audio/alicia_choi.wav'
              },
              {
                title: ['Yuki Isami, Natsuki Hiratsuka', 'M. Miyagi “Haru na Umi“'],
                image: 'img/02.jpg',
                description: 'Amaizing description',
                audio: 'audio/yuki.wav'
              },
              {
                title: ['Robert Silverman', 'F.Chopin “Minute Waltz Op. 64”'],
                image: 'img/12.jpg',
                imageHeight: 320,
                description: 'Amaizing description',
                audio: 'audio/silverman.wav'
              },
              {
                title: ['Maria Budacova', 'F. Liszt “Fantasie und Fugue”'],
                image: 'img/04.jpg',
                description: 'Amaizing description',
                audio: 'audio/liszt.wav'
              },
              {
                title: ['Vienna Philharmonic', 'Martha Argerich, Zubin Mehta', 'M. Ravel “Piano Concerto in G major”'],
                image: 'img/05.jpg',
                description: 'Ravel "Piano Concerto in G major.Presto"',
                // audio: 'audio/05 Ravel "Piano Concerto in G major.Presto".wav',
                audioLink: 'https://music.apple.com/us/song/piano-concerto-in-g-major-m-83-iii-presto-live/1791729349',
              },
              {
                title: ['Vienna Philharmonic, Franz Welser-Möst', 'A. Schönberg “Variations for Orchestra”'],
                image: 'img/06.jpg',
                description: 'Schoenberg "Variations for Orchestra. VII. Sehr rasch"',
                audioLink: 'https://music.apple.com/us/song/variations-for-orchestra-op-31-variation-vii-langsam/1788541496',
                // audio: 'audio/06 Schoenberg "Variations for Orchestra. VII. Sehr rasch".wav'
              },
              {
                title: ['Munich Philharmonic', 'A. Marcon, J.Lezhneva, S.Mingardo', 'G.B. Pergolesi “Stabat Mater”'],
                image: 'img/07.jpg',
                description: 'G.B. Pergolesi "Fac, ut ardeat cor meum"',
                audioLink: 'https://music.apple.com/us/song/stabat-mater-in-f-minor-p-77-viii-fac-ut-ardeat-cor-meum/1803421663',
                // audio: 'audio/07 G.B. Pergolesi "Fac, ut ardeat cor meum".wav'
              },
              {
                title: ['Olga Riazantceva-Schwarz "One Day"'],
                image: 'img/08.jpg',
                description: 'Olga Riazantceva-Schwarz "One Day"',
                audio: 'audio/08_olga_riazantceva-schwarz_one_day.wav'
              },
              {
                title: ['Sirius Quartet', 'S. Jayaram "Sahasranamam"'],
                image: 'img/09.jpg',
                description: 'Sirius Quartet_Sunjay Jayaram "Sahasranamam"',
                audio: 'audio/09_sirius_quartet_sunjay_jayaram_sahasranamam.wav'
              },
              {
                title: ['Maximilian Vogler, Sebastian Issler', 'F. Schubert “Sehnsucht”'],
                image: 'img/maximilian.png',
                imageHeight: 320,
                description: 'Amaizing description',
                audio: 'audio/maximilian.wav',
              },
              {
                title: ['Charles Ives', '"The Unanswered Question"'],
                image: 'img/oliver.jpg',
                imageHeight: 320,
                description: 'Amaizing description',
                audioLink: 'https://music.apple.com/ch/album/ives-the-unanswered-question-single/1604656570?l=en'
              },
              {
                title: ['JACK Quartet', 'Zosha Di Castri “Quartet No. 1”'],
                image: 'img/08_quartet.jpg',
                description: 'Amaizing description',
                audio: 'audio/jack.wav',
                link: {
                  url: 'https://naxosdirect.com/items/zosha-di-castri-tachitipo-514061',
                  title: 'Checkout more'
                }
              },
              {
                title: ['Abaco Orchester, V. Alekseenok, N. Boeva', 'G. Mahler “Kindertotenlieder”'],
                image: 'img/10.jpg',
                imageHeight: 320,
                description: 'Amaizing description',
                audio: 'audio/abaco.wav'
              },
              {
                title: ['Bob Reynolds Group "Crush"'],
                image: 'img/14.jpg',
                description: 'Bob Reynolds Group "Crush"',
                audio: 'audio/14_bob_reynolds_group_crush.wav'
              },
              {
                title: ['Max.bab "152nd Street"'],
                image: 'img/15.jpeg',
                description: 'Max.bab "152nd Street"',
                audio: 'audio/15_max.bab_152nd_street.wav'
              },
              {
                title: ['Renner "Blessing"'],
                image: 'img/16.jpg',
                description: 'Renner "Blessing"',
                audio: 'audio/16_renner_blessing.wav'
              },
              {
                title: ['C.Debussy, arr. Chris Gall "Rêverie"'],
                image: 'img/17.jpg',
                description: 'C.Debussy, arr. Chris Gall "Rêverie"',
                audio: 'audio/17_c._debussy_arr._chris_gall_reverie.wav'
              },
              {
                title: ['Moritz Stahl Quintett', '"Procrastination Episode"'],
                image: 'img/18.jpg',
                description: 'Moritz Stahl Quintett "Procrastination Episode"',
                audio: 'audio/18_moritz_stahl_quintett_procrastination_episode.wav'
              },
              {
                title: ['Elina Duni & Rob Luft "Kur e Percolla Ylberin" (Live at Unterfahrt)'],
                image: 'img/19.jpg',
                description: 'Elina Duni & Rob Luft "Kur e Percolla Ylberin" (Live at Unterfahrt)',
                audio: 'audio/19_elina_duni_rob_luft_kur_e_percolla_ylberin_live_at_unterfahrt.wav'
              },
              {
                title: ['Fred Hersch Trio "You’re my everything"', '(Live at Unterfahrt)'],
                image: 'img/20.jpg',
                description: 'Fred Hersch Trio "You’re my everything" (Live at Unterfahrt)',
                audio: 'audio/20_fred_hersch_trio_youre_my_everything_live_at_unterfahrt.wav'
              },
              {
                title: ['Tora Collective "Xehorismata"', '(Live at Unterfahrt)'],
                image: 'img/21.jpg',
                description: 'Tora Collective "Xehorismata" (Live at Unterfahrt)',
                audio: 'audio/21_tora_collective_xehorismata_live_at_unterfahrt.wav'
              },
              {
                title: ['Yellowjackets "Intrigue"', '(Live at Unterfahrt)'],
                image: 'img/22.jpg',
                description: 'Yellowjackets "Intrigue" (Live at Unterfahrt)',
                audio: 'audio/22_yellowjackets_intrigue_live_at_unterfahrt.wav'
              },
              {
                title: ['Mark Litteri Group "Naptime"', '(Live at Unterfahrt)'],
                image: 'img/23.jpg',
                description: 'Mark Litteri Group "Naptime" (Live at Unterfahrt)',
                audio: 'audio/23_mark_litteri_group_naptime_live_at_unterfahrt.wav'
              },
              {
                title: ['Prepared "Modul Drei I"'],
                image: 'img/24.jpg',
                description: 'Prepared "Modul Drei I"',
                audio: 'audio/24_prepared_modul_drei_i.wav'
              },
            ],
          }
        },
        mounted() {
            this.$el.style.maxHeight = 'fit-content'
        }
    }
</script>
<style>
    .works {
        display: flex;
        flex-wrap: wrap;
        background: linear-gradient(0deg, rgba(241,241,242,1) 100%, rgba(183,228,247,1) 100%);
    }
    .work {
        width: 100%;
      overflow: hidden;
    }
    .display-tablet {
        display: none;
    }
    .display-deckstop {
        display: block;
    }
    @media screen and (max-width: 1200px) {
        .work {
            width: 100%;
        }
    }
    @media screen and (max-width: 768px) {
        .display-tablet {
            display: block;
        }
        .display-deckstop {
            display: none;
        }
    }
</style>
